import {createFileRoute} from "@tanstack/react-router";
import {profileNavigationItems} from "@/common/const/profile/navigation.const.profile";
import {clsx} from "@/utils/clsx";
import styles from "./index.module.scss";
import {Tabs} from "@/components/ui/Tabs/Tabs";

export const Route = createFileRoute("/_mainLayout/profile/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className={styles.profile}>
      <h1 className={styles.title}>Profile settings</h1>
      <Tabs items={profileNavigationItems} className={clsx(styles.desktop)}/>
    </div>
  );
}
